import React from 'react';
import { useQuery } from 'react-query';

import { getMyCommunitiesMarketRate } from 'apis/RecommendationsAPI';
import ErrorMessage from 'components/lib/ErrorMessage';
import Loader from 'components/lib/Loader';
import { MyCommunitiesRateGap } from 'types/recommendations';

import { getCompetitorComparisonLabel } from '../constants';
import MyCommunitiesRateComparisonTable from '../MyCommunitiesRateComparisonTable';
import MyCommunitiesDetailsModal from './MyCommunitiesDetailsModal';

type Props = {
  communityId: number;
  communityName: string;
  rateGap: MyCommunitiesRateGap | null;
  onClose: () => void;
};

const SUBTITLE = 'Minimum prices per room type';

const getSubtitle = (rateGap: MyCommunitiesRateGap | null) => {
  if (!rateGap) return SUBTITLE;

  const percent = Math.round(rateGap.diff_percent);
  const comparison = getCompetitorComparisonLabel(rateGap.competitor_count);
  return `${SUBTITLE} · largest gap: ${rateGap.care_type_name} · ${rateGap.room_type} ${percent > 0 ? '+' : ''}${percent}% ${comparison}`;
};

const MarketRateModal = ({ communityId, communityName, rateGap, onClose }: Props) => {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['my-communities-market-rate', communityId],
    queryFn: () => getMyCommunitiesMarketRate(communityId),
    enabled: Boolean(communityId),
    refetchOnWindowFocus: false,
  });

  return (
    <MyCommunitiesDetailsModal open onClose={onClose} title={communityName} subtitle={getSubtitle(rateGap)}>
      <ErrorMessage text="Failed to load market rates. Please try again." active={isError} />
      <Loader active={isLoading} />
      {!isError && !isLoading && (
        <MyCommunitiesRateComparisonTable
          careTypes={data}
          defaultActiveCareTypeId={rateGap?.care_type_id ?? undefined}
          rateGap={rateGap}
        />
      )}
    </MyCommunitiesDetailsModal>
  );
};

export default MarketRateModal;
